import React from 'react';
import { Link } from 'react-router-dom';
import loadable from '@loadable/component';
import { FILTER_TYPES, PRODUCT_VARIANT_ABBREVIATIONS } from '../../../shared/enums';
import { filterBillboardStatic } from '../../static-data';

const LazyImg = loadable(() => import('../common/LazyImg'));

/**
 * @param page
 * @returns {JSX.Element}
 * @constructor
 */
const FilterBillboard = ({ page }) => {
  const {
    type,
    text,
    titleImage,
    mediaImage,
    backgroundColor,
  } = filterBillboardStatic[page]
    || filterBillboardStatic[PRODUCT_VARIANT_ABBREVIATIONS.BASIC_BREATHER];

  return (
    <div className='filter-billboard filter-billboard--landscape-image' style={{ backgroundColor }}>
      <div className='filter-billboard__wrap'>
        <div className='filter-billboard__content'>
          <Link to='/filters' className='btn btn--outline'>
            <svg className='icon icon-left-arrow'>
              <use xlinkHref='#icon-left-arrow' />
            </svg>
            Go back
          </Link>
          <h1 className='filter-billboard__title'>
            <LazyImg src={titleImage} alt={type} />
            {page === 'PC' ? <span className='filter-billboard__title-into'>The</span> : 'The'}
            {' '}
            {type}
            .
          </h1>
          <p>
            {text}
          </p>
        </div>
        <figure className='filter-billboard__media'>
          <LazyImg src={mediaImage} alt={`${FILTER_TYPES[page]}-hero`} />
        </figure>
      </div>
    </div>
  );
};

export default FilterBillboard;
